let autocomplete;

let pin = `<svg class="listPin" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M16.114-0.011c-6.559 0-12.114 5.587-12.114 12.204 0 6.93 6.439 14.017 10.77 18.998 0.017 0.020 0.717 0.797 1.579 0.797h0.076c0.863 0 1.558-0.777 1.575-0.797 4.064-4.672 10-12.377 10-18.998 0-6.618-4.333-12.204-11.886-12.204zM16.515 29.849c-0.035 0.035-0.086 0.074-0.131 0.107-0.046-0.032-0.096-0.072-0.133-0.107l-0.523-0.602c-4.106-4.71-9.729-11.161-9.729-17.055 0-5.532 4.632-10.205 10.114-10.205 6.829 0 9.886 5.125 9.886 10.205 0 4.474-3.192 10.416-9.485 17.657zM16.035 6.044c-3.313 0-6 2.686-6 6s2.687 6 6 6 6-2.687 6-6-2.686-6-6-6zM16.035 16.044c-2.206 0-4.046-1.838-4.046-4.044s1.794-4 4-4c2.207 0 4 1.794 4 4 0.001 2.206-1.747 4.044-3.954 4.044z"></path></svg>`;

// Toggle accordion visibility
function toggleAccordion() {
    const accordion = document.getElementById("accordion");
    accordion.style.display = accordion.style.display === "none" ? "block" : "none";
    checkStoredStore();
}

document.addEventListener('DOMContentLoaded', function () {
    if (localStorage.getItem('selectedStore')) {
        if (!localStorage.getItem('selectedStoreLatitude') || !localStorage.getItem('selectedStoreLongitude')) {
            let storeName = localStorage.getItem('selectedStore');
            locationsArray().then(stores => {
                let storeSet = stores.data.locations.edges.filter(store => store.node.name == storeName.replaceAll('"', ''));
                localStorage.setItem("selectedStoreLongitude", `${storeSet[0].node.longitude}`);
                localStorage.setItem("selectedStoreLatitude", `${storeSet[0].node.latitude}`);
            })
        }
    }
});

// Check if a store is stored in local storage and update UI
function checkStoredStore() {
    const storedStore = localStorage.getItem("selectedStore");
    const storedStoreId = localStorage.getItem("selectedStoreId");
    const storedStoreHandle = localStorage.getItem("selectedStoreHandle");
    const storeInfo = document.getElementById("store-info");
    const autocompleteInput = document.getElementById("autocomplete");

    if (storedStore) {
        document.getElementById("store-name").textContent = storedStore.replace(/^"(.*)"$/, '$1');
        document.getElementById("store-name").href = `https://www.bobjane.com.au/pages/${storedStoreHandle}-t-marts`;
        document.getElementById("my-store-btn").textContent = storedStore.replace(/^"(.*)"$/, '$1');
        storeInfo.style.display = "flex";
        autocompleteInput.style.display = "none";

    } else {
        showSearchBox();
    }
}

// Show the search box and hide stored store info
function showSearchBox() {
    document.getElementById("store-info").style.display = "none";
    document.getElementById("autocomplete").style.display = "block";
}

// Haversine formula for distance calculation
function haversineDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the Earth in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

// Handle place selection
function handlePlaceSelection(X, Y) {
    cartLocator(X, Y);
    const userLat = X;
    const userLng = Y;

    // Calculate distances to each store and sort by closest
    locationsArray().then(stores => {
        const distances = stores.data.locations.edges.map(store => {
            const distance = haversineDistance(userLat, userLng, store.node.address.latitude, store.node.address.longitude);
            return { ...store, distance };
        });
        const filteredDistances = distances.filter(store => store.node.name != 'Head Office' && !store.node.name.includes('warehouse') && !store.node.name.includes('pre-order'))
        const closestStores = filteredDistances.sort((a, b) => a.distance - b.distance).slice(0, 3);
        displayClosestStores(closestStores);
    })
}

// Display closest stores in dropdown
function displayClosestStores(stores) {
    const dropdown = document.getElementById("store-dropdown");
    dropdown.innerHTML = ''; // Clear previous results
    dropdown.style.display = 'block'; // Show the dropdown

    stores.forEach(store => {

        // Create main wrapper div for each store
        const storeWrapper = document.createElement('div');
        storeWrapper.className = 'loc-item-wrapper';

        // Create main store link element
        const storeItem = document.createElement('a');
        storeItem.className = 'store-item';
        storeItem.href = `https://www.bobjane.com.au/pages/${store.node.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}-t-marts`;
        storeItem.innerHTML = `${store.node.name} (${store.distance.toFixed(2)} km)`;

        // Create the select button and add it inside the store link
        const selectButton = document.createElement('button');
        selectButton.classList.add("button-primary");
        selectButton.textContent = "Check stock here";
        selectButton.onclick = () => setStore(store.node.name, store.id, store.node.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''), store.node.address.longitude, store.node.address.latitude);

        // Add the main store link to the wrapper
        storeWrapper.appendChild(storeItem);

        // Create footer div for additional actions
        const footerDiv = document.createElement('div');
        footerDiv.className = 'loc-footer';

        // Create 'Get directions' link
        const storeItemDirections = document.createElement('a');
        storeItemDirections.className = 'loc-footer-directions';
        storeItemDirections.innerHTML = `Get directions`;
        storeItemDirections.target = "_blank";  // This will open the link in a new tab
        storeItemDirections.href = `https://www.google.com/maps/dir/?api=1&destination=${store.node.address.latitude},${store.node.address.longitude}`;

        // Create 'Call' link with placeholder phone number
        const callLink = document.createElement('a');
        callLink.className = 'loc-footer-callto';
        callLink.href = `tel:${store.node.address.phone}`; // Replace 'XXX' with the phone number variable if available
        callLink.textContent = 'Call';

        // Create 'View Details' link
        const viewDetails = document.createElement('span');
        viewDetails.className = 'loc-footer-details';
        viewDetails.textContent = 'View Details';

        // Append footer links to footer div
        storeItem.appendChild(viewDetails);
        footerDiv.appendChild(storeItemDirections);
        footerDiv.appendChild(callLink);
        footerDiv.appendChild(selectButton);
        // Append footer div to main store wrapper
        storeWrapper.appendChild(footerDiv);
        // Append the completed store item wrapper to the dropdown container
        dropdown.appendChild(storeWrapper);
    });
}

function setStore(storeName, storeId, storeHandle, storeLong, storeLat) {
    cartLocator(storeLat, storeLong);
    // Store the store name and store ID in local storage with quotes
    localStorage.setItem("selectedStore", `"${storeName}"`);
    localStorage.setItem("selectedStoreId", `${storeId}`);
    localStorage.setItem("selectedStoreHandle", `${storeHandle}`);
    localStorage.setItem("selectedStoreLongitude", `${storeLong}`);
    localStorage.setItem("selectedStoreLatitude", `${storeLat}`);
    // Update the UI to reflect the selected store
    updateStoreUI();
    //showPopup();
}

// Update the UI after selecting a store
function updateStoreUI() {
    document.getElementById("store-dropdown").style.display = "none";
    document.getElementById("autocomplete").style.display = "none";
    toggleAccordion(); // Collapse accordion
}

// Initialize autocomplete
function initAutocomplete() {
    checkStoredStore()
    getLocationInfo().then(([postcodes, suburbs]) => {
        document.getElementById('autocomplete').addEventListener('input', function () {
            if (document.getElementById('autocomplete').value.length == 0) {
                document.getElementById('locationsList').style.display = 'none';
            } else {
                if (isNaN(Number(document.getElementById('autocomplete').value))) {
                    if (document.getElementById('autocomplete').value.length > 2) {
                        const fuseOptions = {
                            includeScore: true,
                            keys: ['name'],
                            threshold: 0.4,
                            shouldSort: true
                        }
                        const fuse = new Fuse(suburbs, fuseOptions)
                        const result = fuse.search(`${document.getElementById('autocomplete').value}`)
                        subSet = result.slice(0, 5);
                        let list = '';
                        for (i = 0; i < subSet.length; i++) {
                            list = `${list}<div class="locOpt" data-lat="${subSet[i].item.latitude}" data-long="${subSet[i].item.longitude}">${pin}${subSet[i].item.name}, ${subSet[i].item.state}</div>`
                        }
                        list = `<div class="locSelect">${list}</div>`;
                        document.getElementById('locationsList').innerHTML = list;
                        document.getElementById('locationsList').style.display = 'block';
                        let places = document.getElementById('locationsList').getElementsByClassName('locOpt');
                        for (i = 0; i < places.length; i++) {
                            places[i].addEventListener('click', function () {
                                handlePlaceSelection(this.dataset.lat, this.dataset.long);
                                document.getElementById('locationsList').style.display = 'none';
                            });
                        }
                    }
                } else {
                    if (document.getElementById('autocomplete').value.length > 1) {
                        let postSet = postcodes.filter(PC => PC.postcode.substring(0, document.getElementById('autocomplete').value.length) == document.getElementById('autocomplete').value && PC.latitude && PC.longitude);
                        postSet = postSet.slice(0, 5)
                        let list = '';
                        for (i = 0; i < postSet.length; i++) {
                            list = `${list}<div class="locOpt" data-lat="${postSet[i].latitude}" data-long="${postSet[i].longitude}">${pin}${postSet[i].postcode}</div>`
                        }
                        list = `<div class="locSelect">${list}</div>`;
                        document.getElementById('locationsList').innerHTML = list;
                        document.getElementById('locationsList').style.display = 'block';
                        let places = document.getElementById('locationsList').getElementsByClassName('locOpt');
                        for (i = 0; i < places.length; i++) {
                            places[i].addEventListener('click', function () {
                                handlePlaceSelection(this.dataset.lat, this.dataset.long);
                                document.getElementById('locationsList').style.display = 'none';
                            });
                        }
                    }
                }
            }
        });
    }).catch(error => {
        console.log('Error loading location data')
    });
}

window.onload = initAutocomplete;

function showPopup() {
    var popup = document.getElementById('popup');
    popup.style.display = 'block'; // Show the popup


    setTimeout(function () {
        popup.style.top = "10px";

    }, 100); // 4000 milliseconds = 4 seconds
    // Set a timeout to hide the popup after 4 seconds
    setTimeout(function () {
        popup.style.display = 'none'; // Hide the popup
        popup.style.top = "-100%";

    }, 2500); // 4000 milliseconds = 4 seconds
}
async function getLocationInfo() {
    let pc = 'https://cdn.shopify.com/s/files/1/0722/6320/5114/files/calculatedPostcodes.json?v=1752122472';
    let sub = 'https://cdn.shopify.com/s/files/1/0722/6320/5114/files/calculatedSuburbsDisambiguated.json?v=1752122474';
    if (window.location.host.includes('green-test')) {
        pc = 'https://cdn.shopify.com/s/files/1/0735/4092/7718/files/calculatedPostcodes.json?v=1750212429';
        sub = 'https://cdn.shopify.com/s/files/1/0735/4092/7718/files/calculatedSuburbsDisambiguated.json?v=1750315927';
    }
    const [postcodesResponse, suburbsResponse] = await Promise.all([
        fetch(pc),
        fetch(sub)
    ]);

    const postcodes = await postcodesResponse.json();
    const suburbs = await suburbsResponse.json();

    return [postcodes, suburbs];
}

async function locationsArray() {
    let req = `{
	locations(first:250) {
		edges {
			node {
				address {
					longitude
					latitude
                    formatted
				}
				name
			}
		}
	}
}`
    const opts = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': sFront
        },
        body: JSON.stringify({ query: req })
    };

    const storesResponse = await fetch(`https://${storeString}.myshopify.com/api/2025-07/graphql.json`, opts);

    const stores = await storesResponse.json()

    return stores

}

async function cartLocator(X, Y) {
    let cartString
    for (i = 0; i < document.cookie.split('; ').length; i++) {
        if (document.cookie.split('; ')[i].includes('cart=')) {
            cartString = decodeURIComponent(document.cookie.split('; ')[i].split('=')[1])
        }
    }
    if (cartString) {
        let queryString = `mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
  cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
    cart {
      id
			buyerIdentity {
				preferences {
					delivery {
						deliveryMethod
						coordinates {
							latitude
							longitude
						}
						pickupHandle
					}
				}
			}
    }
    userErrors {
      field
      message
    }
    warnings {
      code
			message
			target
    }
  }
}`
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': sFront
            },
            body: JSON.stringify({
                query: queryString,
                variables: {
                    cartId: `gid://shopify/Cart/${cartString}`,
                    buyerIdentity: {
                        preferences: {
                            delivery: {
                                deliveryMethod: "PICK_UP",
                                coordinates: {
                                    longitude: JSON.parse(Y),
                                    latitude: JSON.parse(X),
                                    countryCode: "AU"
                                }
                            }
                        }
                    }
                }
            })
        };

        fetch(`https://${storeString}.myshopify.com/api/2025-07/graphql.json`, options)
            .then(response => response.json())
            .catch(err => console.error(err));
    }
}